import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  parseFractionLikeInput as parseFraction,
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // boki 3..20
  const a = pick(A), b = pick(A);
  const P = a * b;
  return { type: "RectangleAreaFromSidesTask", data: { a, b, P } };
}

export function renderTask({ data }) {
  const { a, b } = data;
  return (
    <div style={{ marginTop: 8 }}>
      Dany jest prostokąt o bokach <InlineMath math={`a=${a}`} /> i <InlineMath math={`b=${b}`} />.
      Oblicz jego pole <InlineMath math={"P"} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="P"
      placeholder="np. 60"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.P) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`P=${data.P}`} />;

export function renderExplanation({ data }) {
  const { a, b, P } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <div><strong>Krok 1.</strong> Wzór na pole prostokąta: <InlineMath math={'P=a\\cdot b'} />.</div>
      <BlockMath math={`P=${a}\\cdot ${b}=${P}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, "P")} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
